import * as types from '../actionTypes';
import Resource from "../../services/Resource";

export function loadCompanyCoverRegionsSuccess(companyCoverRegions) {
    return {type: types.LOAD_COMPANY_COVER_REGIONS_SUCCESS, companyCoverRegions};
}

export function loadCompanyCoverRegions() {
    return function (dispatch) {
        return Resource.all('api/privateV1/regions').then(companyCoverRegions => {
            dispatch(loadCompanyCoverRegionsSuccess(companyCoverRegions));
        }).catch(error => {
            throw  error;
        });
    }
}



// WEBPACK FOOTER //
// ./web/src/actions/company-cover-regions/companyCoverRegionsActions.js